import { Button, Checkbox, FormControlLabel, FormGroup, Paper, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useMemo, useState } from "react";
import appConfig from "src/config/env";
import { COMMOM_STATUS, EXPORT_TYPE, EXPORT_TYPE_TRANSLATETRANSLATE, orderStatusFormatted, PRINT_SIZE } from "src/constant";
import useOrderPrint from "src/hooks/orders/useOrderPrint";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";

export default function PrepareBulkPrint({ total, warehouseId, setTotal, orderState }) {
  const SLIP_OPTIONS = useMemo(() => {
    const item = [
      { type: EXPORT_TYPE.PreparationList, disabled: orderState.status === orderStatusFormatted.WaitToExport ? false : true },
      { type: EXPORT_TYPE.PickingList, disabled: orderState.status === orderStatusFormatted.ReadyToPick ? false : true },
      { type: EXPORT_TYPE.DeliveredReceipt, disabled: true },
      { type: EXPORT_TYPE.WarehouseExport, disabled: true },
    ];
    return item;
  }, [orderState.status]);

  const [outputType, setOutputType] = useState([]);
  const [logId, setLogId] = useState();
  const { trigger: printAll } = useOrderPrint();
  const { mutate } = useProcessLogDetail(logId, {
    warehouse: warehouseId,
  });

  const handlePrintAllOrders = async () => {
    const res = await printAll({
      body: {
        orderIds: total,
        pageSize: PRINT_SIZE.a6,
        warehouse: warehouseId,
        outputFiles: [EXPORT_TYPE.PickingList],
      },
    });
    if (res?.success) {
      handleGetLog(res?.data?._id);
      setLogId(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: 'notistack-confirm' });
    }
    return enqueueSnackbar(res?.error?.message ?? "Không xuất được phiếu", { variant: "error" });
  };

  const handleGetType = (e) => {
    const { value, checked } = e.target;

    setOutputType((prev) => (checked ? [...prev, value] : prev.filter((v) => v !== value)));
  };

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;
    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            setTotal([]);
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  useEffect(() => {
    setOutputType([orderState.status === orderStatusFormatted.WaitToExport ? EXPORT_TYPE.PreparationList : EXPORT_TYPE.PickingList]);
  }, [orderState.status]);

  return (
    <Paper sx={{ p: "12px" }}>
      <Typography
        variant="body1"
        fontWeight="bold"
        mb="10px"
      >
        Tạo phiếu hàng loạt
      </Typography>

      <Typography
        variant="body2"
        mb="18px"
      >
        <strong>({total?.length ?? 0})</strong> Đơn hàng được chọn
      </Typography>

      <FormGroup>
        {SLIP_OPTIONS.map(({ type, disabled }) => {
          return (
            <FormControlLabel
              key={type}
              label={EXPORT_TYPE_TRANSLATETRANSLATE[type]}
              disabled={disabled}
              control={
                <Checkbox
                  value={type}
                  checked={outputType.includes(type)}
                  onChange={handleGetType}
                  disabled={disabled}
                />
              }
            />
          );
        })}
      </FormGroup>
      <Button
        disabled={total?.length === 0 || outputType.length === 0}
        onClick={handlePrintAllOrders}
        sx={{ mt: "12px" }}
        fullWidth
        variant="contained"
      >
        Tạo phiếu
      </Button>
    </Paper>
  );
}
